import { ShowImageDialogComponent } from './../dialogs/show-image-dialog.component';
import { NotebookPresentationDialogComponent, PresentationSlide } from '../dialogs/notebook-presentation-dialog/notebook-presentation-dialog.component';
import { Note, Notebook, TodoItemFlatNode, TodoItemNode } from './../../model/notes.model';
import { EditNotebookDialogComponent } from './../dialogs/edit-notebook-dialog.component';
import { DeleteNotebookDialogComponent } from './../dialogs/delete-notebook-dialog.component';
import { CreateNoteDialogComponent } from './../dialogs/create-note-dialog.component';
import { CreateNotebookDialogComponent } from './../dialogs/create-notebook-dialog.component';
import { LocalDatabaseService} from '../../services/firestore/local-database.service';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { DeleteNoteDialogComponent } from '../dialogs/delete-note-dialog.component';
import { NotebooksFirestoreService } from 'src/app/services/firestore/notebooks-firestore.service';
import { NotesFirestoreService } from 'src/app/services/firestore/notes-firestore.service';
import { NotesFilterService } from 'src/app/services/utilites/notes-filter.service';
import { InsertionPointService } from 'src/app/services/firestore/insertion-point.service';
//import { ThrowStmt } from '@angular/compiler';
import { FirebaseStorage, getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { ExportDialogComponent } from '../dialogs/export-dialog.component';
import { Router } from '@angular/router';
import { BreakPointService } from 'src/app/services/utilites/break-point.service';
import { filter, firstValueFrom, Observable, Subscription, take, timeout } from 'rxjs';
import { ViewportScroller } from '@angular/common';
import { SettingsService } from 'src/app/services/firestore/settings.service';
import { MessageService } from 'primeng/api';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { environment } from 'src/environments/environment';
import type {
  NotebookMindMapMoveRequest,
  NotebookMindMapNode,
  NotebookMindMapNodeUpdate
} from '../dialogs/notebook-mind-map-dialog/notebook-mind-map.models';

interface NoteDialogResult {
  textData: string;
  multipleNotes: boolean;
  textArray: string[] | null;
  imageFile: File | null;
  imageSrc: string | ArrayBuffer | null;
}

@Component({
  selector: 'app-notebooks-list',
  templateUrl: './notebooks-list.component.html',
  styleUrls: ['./notebooks-list.component.scss']
})
export class NotebooksListComponent implements OnInit {

@Input() currentPage: string;

/** Map from flat node to nested node. This helps us finding the nested node to be modified */
flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

/** Map from nested node to flattened node. This helps us to keep the same object for selection */
nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

/** A selected parent node to be inserted */
selectedParent: TodoItemFlatNode | null = null;

/** The new item's name */
newItemName = '';

treeControl: FlatTreeControl<TodoItemFlatNode>;

treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

/** The selection for checklist */
checklistSelection = new SelectionModel<TodoItemFlatNode>(false /* multiple */);

addNewNotebookForm = false;

storage: FirebaseStorage;

allIds: string[] = new Array<string>(); // = [];

notesSubscription: Subscription;

loading = false;

expandedNotebookForNotebookPage = false;
expandedNoteForNotebookPage = false;

fontSize: string = '14px';

readonly mindMapEnabled = environment.environmentName === 'web';

confirmDelete = false; // para controlar a exibição dos botões de confirmação

constructor(private _database: LocalDatabaseService, public dialog: MatDialog,
  private notebooksFirestore: NotebooksFirestoreService, private notesFirestore: NotesFirestoreService,
  private insertionPoint: InsertionPointService, private router: Router,
  public breakPointService: BreakPointService, private viewportScroller: ViewportScroller, private settings: SettingsService,
  private messageService: MessageService) {

  //console.log("CRIANDO COMPONENTE NOTENOOKS-LIST - Current page = " + this.currentPage);

  this.storage = getStorage();

  this.treeFlattener = new MatTreeFlattener(
    this.transformer,
    this.getLevel,
    this.isExpandable,
    this.getChildren,
  );
  this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
  this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  _database.resetNotebooksNavigation();

  this.notesSubscription = _database.dataChange.subscribe(data => {
    this.dataSource.data = data;

    console.log("Recebeu data");

    if ((this.currentPage == 'notebook') && (this.treeControl.dataNodes.length > 0)) {

      if (!this.expandedNotebookForNotebookPage) {
        this.expandedNotebookForNotebookPage = true;
        this.treeControl.expand(this.treeControl.dataNodes[0]);
        this.expandTheNode(this.treeControl.dataNodes[0]);
      }

      if (this._database.noteIdToFilter && !this.expandedNoteForNotebookPage) {
        this.expandNotesFromParentsDown(this._database.noteIdToFilter);
      }

    }

  });
}

getNotesFontSize() {
  return this.settings.getNotesFontSize();
}

getNotesLineHeight() {
  const fontSize = this.settings.getNotesFontSize();
  const lineHeight = parseFloat(fontSize.match(/\d+(\.\d+)?/)[0]) * (24/14);
  return lineHeight + 'px';
}

ngOnDestroy(): void {
  //Called once, before the instance is destroyed.
  //Add 'implements OnDestroy' to the class.
  this.notesSubscription.unsubscribe();
}

getAllIds() {

  //console.log("call getAllIds");
  return this.allIds;
}

ngOnInit(): void {
  //console.log("INICIALIZANDO COMPONENTE NOTENOOKS-LIST curren = " + this.currentPage);
  //this._database.setCurrentPage(this.currentPage);
}

ngAfterContentInit(): void {
  //Called after ngOnInit when the component's or directive's content has been initialized.
  //Add 'implements AfterContentInit' to the class.
  if (this.currentPage == 'notebook') {
    console.log("ngAfterViewInit");

    if (this.treeControl.dataNodes.length > 0) {

      if (!this.expandedNotebookForNotebookPage) {
      this.expandedNotebookForNotebookPage = true;
      this.treeControl.expand(this.treeControl.dataNodes[0]);
      this.expandTheNode(this.treeControl.dataNodes[0]);
      }

      if (this._database.noteIdToFilter && !this.expandedNoteForNotebookPage) {
       this.expandNotesFromParentsDown(this._database.noteIdToFilter);
      }
    }

    //this.treeControl.expand(this.treeControl.dataNodes[0]);
    //this.expandTheNode(this.treeControl.dataNodes[0]);
    //console.log('entrou aqui - e: ');
    //console.log(this.treeControl.dataNodes[0]);
  } else if (this.currentPage == 'insertion-point') {
    this.markInsertLocation();
  }
}

  private expandNotesFromParentsDown(nodeId: string) {

    if (!nodeId) {
      return;
    }

    const flatNode = this.treeControl.dataNodes.find(x => x.id === nodeId);

    if (!flatNode) {
      return;
    }

    const itemNode = this.flatNodeMap.get(flatNode);

    if (!itemNode) {
      return;
    }

    this.expandedNoteForNotebookPage = true;

    // pecorre todos pais de itemNode e expand todos até itemNode, e expandi-lo tambem se tiver filhos, mas expande primeiro os pais
    let node = itemNode;

    //criar um array para flatNodes
    let flatNodesToExpand = new Array<TodoItemFlatNode>();

    if (node.children && node.children.length > 0) {
      flatNodesToExpand.push(flatNode);
    }

    node = node.parentRef;


    while (node.parentRef) { // if it is notebook, it was already expanded
      flatNodesToExpand.push(this.nestedNodeMap.get(node));
      node = node.parentRef;
    }

    // expand the flatNodesToExpand from the last add to the first
    for (let i = flatNodesToExpand.length - 1; i >= 0; i--) {
      this.treeControl.expand(flatNodesToExpand[i]);
      this.expandTheNode(flatNodesToExpand[i]);
    }

    console.log("Before scroll for id = " + nodeId);


    /*
    setTimeout(() => {
      this.scrollToElement(nodeId);
    }, 200);*/

  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {

    element.scrollIntoView({ behavior: 'smooth', block: 'start' });

    //console.log("Scrolling to element");
    }
  }

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  // Aqui se nao pegou ainda pega do banco de dados (reescreve funcao)
  // Lê tudo no começo, só depois faz por demanda
  //getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;
  getChildren = (node: TodoItemNode): TodoItemNode[] => {
    // se é caderno e é expandable e nao tem filhos
    //   sinaliza pro serviço pegar um subscribe do pai.
    //  assim q pegar -- chama expandle no nodo

    //console.log(`Get Children para id = ${node.item}`);
    return node.children;
  };

  //hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;
  hasChild = (_: number, _nodeData: TodoItemFlatNode) => this.flatNodeMap.get(_nodeData).has_child;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => {
    //(_nodeData.item === null || _nodeData.item === '') && !_nodeData.image_path;
    if ((_nodeData.item === null || _nodeData.item === '') && !_nodeData.image_path)
      return true;

    //console.log("hasNoContent was called for = " + _nodeData.item );

    if (this.filterOutNote(_nodeData))
      return true;

    return false;
  }

/**
 * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
 */
transformer = (node: TodoItemNode, level: number) => {

  // Se caderno e nao carregou os filhos e esta marcado com insertion point
  // Na current position ve se pai tem filho ou nao, se nao tive e for adicionado.
  // Tmb a questao de prioridade, onde armazenar quando nao carregou os filhos e é adicionado no cardero

  // Caderno vai ter q adicionar prioridade max dos filhos direto
  // Se ao adicionar nota em caderno no cloudfunc e o cardeno ta como se nao tem filho, atualiza cardrno
  //   Caso tmb de checar se caderno ta marcado com has_chield mas foram removido, ai tem q checar e atualizar


  //Bug: as vezes nao chama o listener quando clica no expandir - ver isso


  let existingNode = this.nestedNodeMap.get(node);
  let hasToToggle= false;

  if (existingNode) {
    if ( (node.has_child && !existingNode.expandable) || (!node.has_child && existingNode.expandable)) {
      //console.log("caiu aqui existingNode  en node text is: "  + node.item);
      this.flatNodeMap.delete(existingNode);
      this.nestedNodeMap.delete(node);
      if (this.checklistSelection.isSelected(existingNode))
        hasToToggle = true;
      existingNode = new TodoItemFlatNode();
    }
  } else {
    // if loading only now and it is the selected node
    if (this.insertionPoint.insertionPointLocation && (this.insertionPoint.insertionPointLocation.parent_id == node.id))
      hasToToggle = true;
  }

  // tem q ver se tem uma difetenca dai se tem q criar um novo tmb
  const flatNode =
    existingNode /*&& existingNode.item === node.item */ ? existingNode : new TodoItemFlatNode();


  // FAZ Isso de novo

  // se muda de !expandable -> expandable
  // remove e coloca um novo
  //const notexpandableToExpandable = existingNode && (!existingNode.expandable && node.children);

  //const flatNode =
  //  (existingNode && (existingNode.item === node.item) && (!notexpandableToExpandable)) ? existingNode : new TodoItemFlatNode();

  flatNode.item = node.item;

  flatNode.level = level;

  // check if its parent change, collapse and expand parent to fix padding identation
 // if (node.changedParent) {

    //só muda o level dele e dos filhos tmb maybe

    //node.changedParent = false;
    //flatNode.level =1;
    /*
    console.log("Change parent");
    const flatParent =  this.nestedNodeMap.get(node.parentRef);
    node.changedParent = false;

   // this.treeControl.collapse(flatParent);

    // is expanded colladpse and expand again
    if (this.treeControl.isExpanded(flatParent)) {
      console.log("Parent is expanded");
      this.treeControl.collapse(flatParent);
      //this.treeControl.expand(flatParent);
    } */
  //}


  flatNode.id = node.id;

  flatNode.image_path = node.image_path;
  //Arruma bug

  //node.has_child = true;
  flatNode.expandable = node.has_child;//!!node.children?.length;

  // se filter out nem adiciona melhor fazer assim
  //flatNode.filterOut = node.filterOut;

  //this.flatNodeMap.delete(flatNode);
  //this.nestedNodeMap.delete(node);

  this.flatNodeMap.set(flatNode, node);
  this.nestedNodeMap.set(node, flatNode);

  if (hasToToggle)
    this.checklistSelection.toggle(flatNode);

  //console.log(`Passou aqui. item = ${flatNode.item}, explandable = ${flatNode.expandable} `);


  //console.log("Chamou transformer for note:: " + node.item );
  //console.log("My parent is:: " + node.parent_id );

  return flatNode;
};

/** Whether all the descendants of the node are selected. */
descendantsAllSelected(node: TodoItemFlatNode): boolean {
  const descendants = this.treeControl.getDescendants(node);
  const descAllSelected =
    descendants.length > 0 &&
    descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
  return descAllSelected;
}

/** Whether part of the descendants are selected */
descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
  const descendants = this.treeControl.getDescendants(node);
  const result = descendants.some(child => this.checklistSelection.isSelected(child));
  return result && !this.descendantsAllSelected(node);
}

/** Toggle the to-do item selection. Select/deselect all the descendants node */
todoItemSelectionToggle(event: MatCheckboxChange, node: TodoItemFlatNode): void {

/* if (!this.checklistSelection.isSelected(node))
   // deselect all
   this.checklistSelection.clear();*/

   if (this.checklistSelection.isSelected(node)) {
    event.source.checked = true; // força ficar marcado
    return;
  }

   this.checklistSelection.toggle(node);

  /*
  const descendants = this.treeControl.getDescendants(node);
  this.checklistSelection.isSelected(node)
    ? this.checklistSelection.select(...descendants)
    : this.checklistSelection.deselect(...descendants);

  // Force update for the parent
  descendants.forEach(child => this.checklistSelection.isSelected(child));*/
  //this.checkAllParentsSelection(node);

  this.setInsertionPoint(node);
}

/** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
todoLeafItemSelectionToggle(event: MatCheckboxChange, node: TodoItemFlatNode): void {
/* if (!this.checklistSelection.isSelected(node))
 // deselect all
   this.checklistSelection.clear();*/

   if (this.checklistSelection.isSelected(node)) {
    event.source.checked = true; // força ficar marcado
    return;
  }

  this.checklistSelection.toggle(node);
  //this.checkAllParentsSelection(node);

  this.setInsertionPoint(node);
}

setInsertionPoint(node: TodoItemFlatNode) {
  const nodeItem = this.flatNodeMap.get(node);

  this.insertionPoint.saveCurrentLocation(nodeItem).then(() => {
    console.log("Insertion point changed");
    this.messageService.clear();
    this.messageService.add({  severity: 'success', summary: 'Success', detail: 'Insertion point successfully changed' });
  }).catch((error) => {
    this.messageService.clear();
    this.messageService.add({  severity: 'error', summary: 'Error', detail: 'Error changing insertion point' });
  });

  this.notebooksFirestore.updateNotebook({
    id: nodeItem.notebook_id
  });

}

/* Checks all the parents when a leaf node is selected/unselected */
checkAllParentsSelection(node: TodoItemFlatNode): void {
  let parent: TodoItemFlatNode | null = this.getParentNode(node);
  while (parent) {
    this.checkRootNodeSelection(parent);
    parent = this.getParentNode(parent);
  }
}

/** Check root node checked state and change it accordingly */
checkRootNodeSelection(node: TodoItemFlatNode): void {
  const nodeSelected = this.checklistSelection.isSelected(node);
  const descendants = this.treeControl.getDescendants(node);
  const descAllSelected =
    descendants.length > 0 &&
    descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
  if (nodeSelected && !descAllSelected) {
    this.checklistSelection.deselect(node);
  } else if (!nodeSelected && descAllSelected) {
    this.checklistSelection.select(node);
  }
}

/* Get the parent node of a node */
getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
  const currentLevel = this.getLevel(node);

  if (currentLevel < 1) {
    return null;
  }

  const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

  for (let i = startIndex; i >= 0; i--) {
    const currentNode = this.treeControl.dataNodes[i];

    if (this.getLevel(currentNode) < currentLevel) {
      return currentNode;
    }
  }
  return null;
}

//Not used anymore
/** Select the category so we can insert the new item. */
addNewItem(parendNodeFlat: TodoItemFlatNode) {
//  if (!parendNodeFlat)
//   console.log('node == null');
// else
//   console.log(`node = ${parendNodeFlat.item},  level do node = ${parendNodeFlat.level}`);

  const parentNode = this.flatNodeMap.get(parendNodeFlat);

 // ? quando muda só uma proriedade parece que nao atualiza a tela - meio q bugado
  if (/*node.level == 0 && */!parendNodeFlat.expandable) {
   // remove da lista do set depois coloca denovo
    this.flatNodeMap.delete(parendNodeFlat);
    this.nestedNodeMap.delete(parentNode);
  }

  const new_note = this._database.insertItem(parentNode!, '');

  //changed
  //node.expandable = true;
  // this.treeControl.collapse(this.getParentNode(node));
  // this.treeControl.expand(this.getParentNode(node));

 // this.treeControl.collapse(node);
  // end changed

  //original
  //this.treeControl.expand(node);

  //new
  this.treeControl.expand(this.nestedNodeMap.get(parentNode));

  //this._database.dataChange.next(this._database.data);
  return new_note;
}

/** Save the node to database - not actually used */
saveNode(node: TodoItemFlatNode, itemValue: string) {
  const nestedNode = this.flatNodeMap.get(node);
  this._database.updateItem(nestedNode!, itemValue);
}

//not used
handleDelete(node: TodoItemFlatNode) {
 const nestedNode = this.flatNodeMap.get(node);

 this.notesFirestore.deleteItem(nestedNode).then( (parentNode: TodoItemNode) => {
     // checa
     // se caderno root
     // se nao tem mais filhos
     //changed
     if (parentNode && ((!parentNode.children) || (parentNode.children.length < 1))) {
        this.flatNodeMap.delete(this.nestedNodeMap.get(parentNode));
        this.nestedNodeMap.delete(parentNode);
        this._database.dataChange.next(this._database.data);
     }

 })
}

addNewNotebook(itemValue: string) {
 this.notebooksFirestore.addNewNotebook(itemValue);
 this.addNewNotebookForm = false;
}

refreshTreeData() {
  const data = this.dataSource.data;
  this.dataSource.data = [];
  this.dataSource.data = data;
}

expandTheNode(node: TodoItemFlatNode) {
  //console.log("Expand The Node, is expandled = " + node.item);
  //console.log(this.treeControl.isExpanded(node));


  let nodeItem = this.flatNodeMap.get(node);

  //if (!nodeItem.parent_id.length && !this.treeControl.isExpanded(node) && nodeItem.has_child && !nodeItem.children)
  //if is notebook, and it os not listening child
  if (!node.level && this.treeControl.isExpanded(node) && nodeItem.has_child && !nodeItem.notesListeningStarted)
   //this._database.getAllNoteFromNotebook(nodeItem);
    this.notesFirestore.startNotesListenerForNotebook(nodeItem);


  if (!node.level || !this.breakPointService.isHandset || !this.treeControl.isExpanded(node)) {
    //console.log("Expand The Node,  node.level is  " + node.level);
    return;
  }

  nodeItem.notebookRef.expandadedStack.push(nodeItem);
  nodeItem.notebookRef.currentExpandedNode = nodeItem;

  // tem que avisar para aplicar condicoes When
  console.log("Expand The Node call dataChage");
  this.refreshTreeData();


  // aqui faz pegar os fihos se nao pegou ainda
  // caso seja o cardeno pai

  // depois quando adidionar um node..
  //    checa se o pai é um caderno ou qualquer outro
  //    se for sem filho -- tem que marcar que agora tem filho

  //#1 Marca que tem filho - has_children - os pais se nao tem ainda
  //      ver se da pra pegar o tamanho
  //       https://stackoverflow.com/questions/69051871/flutter-firebase-check-if-collection-is-empty
  //       query with limit 1

  //#2 [ok] Is_expandable = ver o has_children ao invé de children Array
     //  deixa assim mesmo ou só para notebook nao para filhos

  //#3 [ok] Tira lá de pegar os filhos na inicialização
  //#4 [ok] Chama nessa função caso caderno seja pai e filho nao tão carregado ainda
       //  checa se filhos estao vazio e nao carregado
  //#5 [ok] Chama funcao do service que cria um subscribe e q fica escutando depois em aberto
  //#6 [ok] Dai primeiro faz unsub depois de ler, como está, pra testar
  //#7 [ok] - Deixa escutando sub -  Depois quando muda um nodo e ad ou remov - checa se já existe no array para nao criar novo

   // #7.1
   //    diferencas do subcribe com angularfire e do firebase
   //  Ver esse video: https://www.youtube.com/watch?v=3aoxOtMM2rc
   //      acho que angularFire as mudanca pega todos documentos - faz leitura para todos.
   //      no fireabse sdk melhor com snapshot ai sim
   //    https://cloud.google.com/firestore/docs/query-data/listen?hl=pt-br
   //  Estudar angularFire e fiebarse e suas diferenças
   // pelos testes que fiz -- se mudar um - le só uma vezz
   //  tentar tratar casos se removido ou se modificado - além do adicionado..


   // #8 -- Faz isso depois dai. - considera tudo com has_child now
     // Ao adicionar nodo como caderno comco parent
     //   Se primeiro filho = tem q salvar no banco de dados has child
       // faz em todo loca isso
     //   Ao remover - se último filho marca como false no banco -- vai saber se é último



   // #9 considerarn quando tem novo caderno -- atualizar has chield
     // deixar o subscrive ativo para cadernos tmb -- se já existe não adiciona..
}


markInsertLocation() {
  const nodeLocation = this.insertionPoint.getInsertionPointNode();

  if (nodeLocation) {
    // if not select - seleciona
    if (!this.checklistSelection.isSelected(this.nestedNodeMap.get(nodeLocation)))
      this.checklistSelection.toggle(this.nestedNodeMap.get(nodeLocation));
  }

}


deleteNotebookWithChild(nodeFlat: TodoItemFlatNode) {
  this.notebooksFirestore.deleteNotebook(this.flatNodeMap.get(nodeFlat));
}

openDialogDeleteNotebook(nodeFlat: TodoItemFlatNode) {
  const dialogRef = this.dialog.open(DeleteNotebookDialogComponent, {
    width: '400px',
    data: {  }
  });

  dialogRef.afterClosed().subscribe(result => {
    //console.log(`Dialog result: ${result}`);
    if (result)
      this.notebooksFirestore.deleteNotebook(this.flatNodeMap.get(nodeFlat));
  });
  //this._database.deleteNotebook(this.flatNodeMap.get(nodeFlat));
}

openDialogEditNotebook(nodeFlat: TodoItemFlatNode) {
  const nodeItem = this.flatNodeMap.get(nodeFlat);
  if (!nodeItem) {
    return;
  }

  void this.editNotebookNode(nodeItem).catch(error => console.log('Error = ', error));
}

openDialogNewNote(parendNodeFlat: TodoItemFlatNode) {
  const parentNode = this.flatNodeMap.get(parendNodeFlat);
  if (!parentNode) {
    return;
  }

  void this.createNotesForParent(parentNode).catch(error => console.log('Error = ', error));
}

openDialogEditNote(nodeFlat: TodoItemFlatNode) {
  const nodeItem = this.flatNodeMap.get(nodeFlat);
  if (!nodeItem) {
    return;
  }

  void this.editTodoNote(nodeItem).catch(error => console.log('Error = ', error));
}

deleteNoteWithouChild(nodeFlat: TodoItemFlatNode) {
  this.notesFirestore.deleteItem(this.flatNodeMap.get(nodeFlat));
}

openDialogDeleteNote(nodeFlat: TodoItemFlatNode) {
  const nodeItem = this.flatNodeMap.get(nodeFlat);
  if (!nodeItem) {
    return;
  }

  void this.confirmAndDeleteNote(nodeItem).catch(error => console.log('Error = ', error));

}

private async createNotesForParent(parentNode: TodoItemNode): Promise<Note[] | undefined> {
  const dialogRef = this.dialog.open(CreateNoteDialogComponent, {
    width: '400px',
    data: null
  });
  const result = await firstValueFrom(dialogRef.afterClosed()) as NoteDialogResult | undefined;
  if (!result) {
    return undefined;
  }

  this.loading = true;
  try {
    if (!result.multipleNotes) {
      const note = await this.notesFirestore.addNewNote(
        parentNode,
        result.textData,
        result.imageFile ?? undefined
      );
      return [note];
    }

    const notes: Note[] = [];
    for (const text of result.textArray ?? []) {
      if (text) {
        notes.push(await this.notesFirestore.addNewNote(parentNode, text));
      }
    }
    return notes;
  } finally {
    this.loading = false;
  }
}

private async editNotebookNode(nodeItem: TodoItemNode): Promise<NotebookMindMapNodeUpdate | undefined> {
  const dialogRef = this.dialog.open(EditNotebookDialogComponent, {
    width: '400px',
    data: nodeItem.item
  });
  const result = await firstValueFrom(dialogRef.afterClosed()) as string | undefined;
  if (!result) {
    return undefined;
  }

  await this.notebooksFirestore.updateNotebookName({ text: result, id: nodeItem.id } as Notebook);
  return {
    text: result,
    imagePath: nodeItem.image_path ?? null,
    imageUrl: nodeItem.imageDownloadUrl ? String(nodeItem.imageDownloadUrl) : null
  };
}

private async editTodoNote(
  nodeItem: TodoItemNode,
  imageUrlOverride?: string
): Promise<NotebookMindMapNodeUpdate | undefined> {
  const currentImageUrl = imageUrlOverride
    ?? (nodeItem.imageDownloadUrl ? String(nodeItem.imageDownloadUrl) : null);
  const dialogRef = this.dialog.open(CreateNoteDialogComponent, {
    width: '400px',
    data: { text: nodeItem.item, imageSrc: currentImageUrl }
  });
  const result = await firstValueFrom(dialogRef.afterClosed()) as NoteDialogResult | undefined;
  if (!result) {
    return undefined;
  }

  this.loading = true;
  try {
    const baseUpdate = {
      text: result.textData,
      id: nodeItem.id,
      priority: nodeItem.priority,
      notebook_id: nodeItem.notebook_id,
      parent_id: nodeItem.parent_id
    } as Note;

    if (result.imageSrc && currentImageUrl !== String(result.imageSrc)) {
      if (!result.imageFile) {
        throw new Error('The selected image file is not available.');
      }

      const oldImagePath = nodeItem.image_path;
      await this.notesFirestore.uploadImageAndUpdateNote(baseUpdate, result.imageFile);
      const newImagePath = baseUpdate.image_path ?? null;
      if (oldImagePath && oldImagePath !== newImagePath) {
        await this.deleteReplacedNoteImage(oldImagePath);
      }
      return {
        text: result.textData,
        imagePath: newImagePath,
        imageUrl: typeof result.imageSrc === 'string' ? result.imageSrc : null
      };
    }

    if (currentImageUrl && !result.imageSrc) {
      const oldImagePath = nodeItem.image_path;
      await this.notesFirestore.updateNote({ ...baseUpdate, image_path: null } as Note);
      if (oldImagePath) {
        await this.deleteReplacedNoteImage(oldImagePath);
      }
      return { text: result.textData, imagePath: null, imageUrl: null };
    }

    await this.notesFirestore.updateNote(baseUpdate);
    return {
      text: result.textData,
      imagePath: nodeItem.image_path ?? null,
      imageUrl: currentImageUrl
    };
  } finally {
    this.loading = false;
  }
}

private async deleteReplacedNoteImage(imagePath: string): Promise<void> {
  try {
    await this.notesFirestore.deleteImageFromStorage(imagePath);
  } catch (error) {
    console.error('Could not delete the replaced note image:', error);
  }
}

private async confirmAndDeleteNote(nodeItem: TodoItemNode): Promise<boolean> {
  const dialogRef = this.dialog.open(DeleteNoteDialogComponent, {
    width: '400px',
    data: { }
  });
  const confirmed = await firstValueFrom(dialogRef.afterClosed()) as boolean | undefined;
  if (!confirmed) {
    return false;
  }

  this.loading = true;
  try {
    const parentNode = await this.notesFirestore.deleteItem(nodeItem);
    if (!parentNode) {
      this.messageService.add({ severity: 'error', summary: 'Notes', detail: 'Could not delete the note.' });
      return false;
    }
    return true;
  } finally {
    this.loading = false;
  }
}

  async openDialogShowImage(nodeFlat: TodoItemFlatNode) {
    //https://www.codegrepper.com/code-examples/javascript/javascript+get+image+size+from+url

    const nodeItem = this.flatNodeMap.get(nodeFlat);

    if (!nodeItem.imageDownloadUrl) {

      try {
        //const storageLocal = getStorage();
        nodeItem.imageDownloadUrl = await getDownloadURL(ref(this.storage, nodeFlat.image_path));
      } catch (error) {
        console.log("Ops error = ", error);
        return;
      }
    }

  //  console.log("imageDownlaodUrl = " + nodeItem.imageDownloadUrl);

    const dialogRef = this.dialog.open(ShowImageDialogComponent, {
      width: 'auto',
      height: 'auto',
      panelClass: 'custom-image-dialog-container',
      data: nodeItem.imageDownloadUrl
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("resultado é = " + result);

        //const nodeItem = this.flatNodeMap.get(nodeFlat);

      }
    });
  }

  async openNotebookPresentation(nodeFlat: TodoItemFlatNode): Promise<void> {
    const selectedNode = this.flatNodeMap.get(nodeFlat);
    const notebookNode = nodeFlat.level === 0 ? selectedNode : selectedNode?.notebookRef;

    if (!selectedNode || !notebookNode) {
      return;
    }

    if (!(await this.ensureNotebookNotesLoaded(notebookNode, 'Presentation'))) {
      return;
    }

    const slides: PresentationSlide[] = [];
    const addChildren = (parent: TodoItemNode, parentPath: string[]): void => {
      const children = [...(parent.children ?? [])].sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));

      for (const child of children) {
        const breadcrumb = [...parentPath, this.presentationPathLabel(child)];
        slides.push({
          id: child.id,
          text: child.item ?? '',
          imagePath: child.image_path ?? undefined,
          imageUrl: child.imageDownloadUrl ?? undefined,
          breadcrumb
        });
        addChildren(child, breadcrumb);
      }
    };

    addChildren(notebookNode, [this.presentationPathLabel(notebookNode)]);

    if (!slides.length) {
      this.messageService.add({ severity: 'info', summary: 'Presentation', detail: 'This notebook has no notes to present.' });
      return;
    }

    const initialIndex = nodeFlat.level === 0 ? 0 : slides.findIndex(slide => slide.id === selectedNode.id);

    if (initialIndex < 0) {
      this.messageService.add({ severity: 'info', summary: 'Presentation', detail: 'This note is no longer in the notebook.' });
      return;
    }

    this.dialog.open(NotebookPresentationDialogComponent, {
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      panelClass: 'notebook-presentation-dialog-panel',
      ariaLabel: 'Notebook presentation',
      closeOnNavigation: true,
      data: { slides, initialIndex }
    });
  }

  async openNotebookMindMap(nodeFlat: TodoItemFlatNode): Promise<void> {
    if (!this.mindMapEnabled) {
      return;
    }

    const selectedNode = this.flatNodeMap.get(nodeFlat);
    const notebookNode = nodeFlat.level === 0 ? selectedNode : selectedNode?.notebookRef;

    if (!selectedNode || !notebookNode) {
      return;
    }

    if (!(await this.ensureNotebookNotesLoaded(notebookNode, 'Mind map'))) {
      return;
    }

    const root = this.createMindMapNode(selectedNode);

    try {
      const { NotebookMindMapDialogComponent } = await import(
        '../dialogs/notebook-mind-map-dialog/notebook-mind-map-dialog.component'
      );

      this.dialog.open(NotebookMindMapDialogComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        maxHeight: '100vh',
        panelClass: 'notebook-mind-map-dialog-panel',
        ariaLabel: 'Notebook mind map',
        closeOnNavigation: true,
        disableClose: true,
        data: {
          root,
          moveNode: (request: NotebookMindMapMoveRequest) => this.moveMindMapNode(selectedNode, request),
          addChildren: (parentNodeId: string) => this.addMindMapChildren(selectedNode, parentNodeId),
          editNode: (nodeId: string, currentImageUrl?: string) =>
            this.editMindMapNode(selectedNode, nodeId, currentImageUrl),
          deleteNode: (nodeId: string) => this.deleteMindMapNode(selectedNode, nodeId)
        }
      });
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Mind map', detail: 'Could not open the mind map.' });
    }
  }

  private async ensureNotebookNotesLoaded(notebookNode: TodoItemNode, featureName: string): Promise<boolean> {
    if (notebookNode.childrenNotesLoaded) {
      return true;
    }

    this.loading = true;

    try {
      // The listener marks the notebook as loaded before it finishes building the tree.
      // The following dataChange emission means all descendants are available.
      const notesLoaded = firstValueFrom(this._database.dataChange.pipe(
        filter(() => notebookNode.childrenNotesLoaded),
        take(1),
        timeout(15000)
      ));

      if (!notebookNode.notesListeningStarted) {
        this.notesFirestore.startNotesListenerForNotebook(notebookNode);
      }

      await notesLoaded;
      return true;
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: featureName, detail: 'Could not load the notebook notes.' });
      return false;
    } finally {
      this.loading = false;
    }
  }

  private createMindMapNode(node: TodoItemNode): NotebookMindMapNode {
    const children = [...(node.children ?? [])]
      .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
      .map(child => this.createMindMapNode(child));

    return {
      id: node.id,
      text: node.item ?? '',
      isNotebook: !node.parentRef,
      imagePath: node.image_path ?? undefined,
      imageUrl: node.imageDownloadUrl ? String(node.imageDownloadUrl) : undefined,
      children
    };
  }

  private async addMindMapChildren(
    rootNode: TodoItemNode,
    parentNodeId: string
  ): Promise<NotebookMindMapNode[] | undefined> {
    const parentNode = this.findMindMapTodoNode(rootNode, parentNodeId);
    if (!parentNode) {
      return undefined;
    }

    try {
      const notes = await this.createNotesForParent(parentNode);
      return notes?.map(note => ({
        id: note.id!,
        text: note.text ?? '',
        isNotebook: false,
        imagePath: note.image_path ?? undefined,
        children: []
      }));
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Mind map', detail: 'Could not add the note.' });
      return undefined;
    }
  }

  private async editMindMapNode(
    rootNode: TodoItemNode,
    nodeId: string,
    currentImageUrl?: string
  ): Promise<NotebookMindMapNodeUpdate | undefined> {
    const node = this.findMindMapTodoNode(rootNode, nodeId);
    if (!node) {
      return undefined;
    }

    try {
      return node.parentRef
        ? await this.editTodoNote(node, currentImageUrl)
        : await this.editNotebookNode(node);
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Mind map', detail: 'Could not update the note.' });
      return undefined;
    }
  }

  private async deleteMindMapNode(rootNode: TodoItemNode, nodeId: string): Promise<boolean> {
    const node = this.findMindMapTodoNode(rootNode, nodeId);
    if (!node || node === rootNode) {
      return false;
    }

    try {
      return await this.confirmAndDeleteNote(node);
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Mind map', detail: 'Could not delete the note.' });
      return false;
    }
  }

  private async moveMindMapNode(rootNode: TodoItemNode, request: NotebookMindMapMoveRequest): Promise<boolean> {
    const node = this.findMindMapTodoNode(rootNode, request.nodeId);
    const targetNode = this.findMindMapTodoNode(rootNode, request.targetNodeId);
    if (!node || !targetNode || node === rootNode || node === targetNode || !node.parentRef) {
      return false;
    }

    let ancestor: TodoItemNode | undefined = targetNode;
    while (ancestor) {
      if (ancestor === node) {
        return false;
      }
      ancestor = ancestor.parentRef;
    }

    const targetNotebookId = targetNode.notebook_id || targetNode.id;
    if (node.notebook_id !== targetNotebookId) {
      return false;
    }

    const newParent = request.position === 'inside' ? targetNode : targetNode.parentRef;
    if (!newParent || (targetNode === rootNode && request.position !== 'inside')) {
      return false;
    }

    const currentChildren = [...(newParent.children ?? [])]
      .sort((first, second) => (first.priority ?? 0) - (second.priority ?? 0));
    const siblingsWithoutNode = currentChildren.filter(child => child.id !== node.id);
    let insertionIndex = siblingsWithoutNode.length;

    if (request.position !== 'inside') {
      const targetIndex = siblingsWithoutNode.findIndex(child => child.id === targetNode.id);
      if (targetIndex < 0) {
        return false;
      }
      insertionIndex = request.position === 'before' ? targetIndex : targetIndex + 1;
    }

    const reorderedChildren = [...siblingsWithoutNode];
    reorderedChildren.splice(insertionIndex, 0, node);
    if (
      newParent === node.parentRef
      && currentChildren.length === reorderedChildren.length
      && currentChildren.every((child, index) => child.id === reorderedChildren[index].id)
    ) {
      return false;
    }

    const previousNode = siblingsWithoutNode[insertionIndex - 1];
    const nextNode = siblingsWithoutNode[insertionIndex];
    const currentMaxPriority = Math.max(
      newParent.maxChildrenPriorityNumber ?? 0,
      ...currentChildren.map(child => child.priority ?? 0)
    );
    const newPriority = previousNode && nextNode
      ? ((previousNode.priority ?? 0) + (nextNode.priority ?? 0)) / 2
      : previousNode
        ? currentMaxPriority + 100
        : nextNode
          ? (nextNode.priority ?? 0) / 2
          : currentMaxPriority + 100;
    const updateParentMetadata = !newParent.has_child || newPriority > currentMaxPriority;

    try {
      if (updateParentMetadata) {
        if (newParent.id === node.notebook_id) {
          await this.notebooksFirestore.updateNotebook({
            id: newParent.id,
            has_child: true,
            max_children_priority: newPriority
          });
        } else {
          await this.notesFirestore.updateNote({
            id: newParent.id,
            notebook_id: newParent.notebook_id,
            has_child: true,
            max_children_priority: newPriority
          });
        }

        const insertionPoint = this.insertionPoint.insertionPointLocation;
        if (insertionPoint?.parent_id === newParent.id) {
          await this.insertionPoint.updateInsertionPointInDb({ priority: newPriority });
        }
      }

      await this.notesFirestore.updateNote({
        id: node.id,
        notebook_id: node.notebook_id,
        parent_id: newParent.id,
        priority: newPriority
      });

      if (updateParentMetadata) {
        newParent.has_child = true;
        newParent.maxChildrenPriorityNumber = newPriority;
      }
      return true;
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Mind map',
        detail: 'Could not move the note.'
      });
      return false;
    }
  }

  private findMindMapTodoNode(node: TodoItemNode, nodeId: string): TodoItemNode | undefined {
    if (node.id === nodeId) {
      return node;
    }

    for (const child of node.children ?? []) {
      const found = this.findMindMapTodoNode(child, nodeId);
      if (found) {
        return found;
      }
    }

    return undefined;
  }

  private presentationPathLabel(node: TodoItemNode): string {
    const firstLine = (node.item ?? '').split(/\r?\n/).map(line => line.trim()).find(line => line.length > 0);
    return firstLine ?? (node.image_path ? 'Image note' : node.parentRef ? 'Untitled note' : 'Notebook');
  }

  openDialogExport(parendNodeFlat: TodoItemFlatNode) {

    const nodeItem = this.flatNodeMap.get(parendNodeFlat);

   // load the children if notebook and chidren have not been loaded yet
   if (!nodeItem.parent_id.length && nodeItem.has_child && !nodeItem.notesListeningStarted)
    this.notesFirestore.startNotesListenerForNotebook(nodeItem);

    this._database.exportFromNode = nodeItem;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      width: '500px',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //console.log("result is = " + result);
      }
  });
}

  isNotebookIndeterminate(nodeFlat: TodoItemFlatNode) {
    if (!this.insertionPoint.insertionPointLocation)
      return false;

    if ((nodeFlat.id === this.insertionPoint.insertionPointLocation.notebook_id) &&
      (nodeFlat.id !== this.insertionPoint.insertionPointLocation.parent_id))
      return true;

    return false;
  }

  //filterInNote(nodeFlat: TodoItemFlatNode) {

  filterOutNote(_nodeData: TodoItemFlatNode)  {

    // faz o check se mobile
    // ai pesquisa por notebook e nodo atual - ultimo expandido (quando expander - marca ele no notebook)
      // usa uma pilha no notebook com os ultimos abertos
    // se nao for filho do ultimo expandido, filtra fora

    let nodeItem = this.flatNodeMap.get(_nodeData);

    if (!nodeItem || !nodeItem.id)
      return false;

    if (this.breakPointService.isHandset && _nodeData.level) {
      if ((nodeItem.parentRef && nodeItem.notebookRef && nodeItem.notebookRef.currentExpandedNode) && (nodeItem.parentRef != nodeItem.notebookRef.currentExpandedNode))
        return true;
    }

    if ((!(this._database.filterOutNotSelected)) || (this.currentPage != 'insertion-point') || (!(this.insertionPoint.insertionPointLocation)))
      return false;

    if (nodeItem.notebook_id != this.insertionPoint.insertionPointLocation.notebook_id)
      return true;


    // só oculta notebooks que não são o insertion point, as notas no notebook selecionada deixa todas visiveis
    return false;

     //se indermindado
    if (this.descendantsPartiallySelected(_nodeData) || this.isNotebookIndeterminate(_nodeData))
      return false;

    // se é o prorpio node
    if (_nodeData.id == this.insertionPoint.insertionPointLocation.parent_id)
      return false;

    // Agora checa se filho nao está na arvore
    let nodeLoop = nodeItem;

    while (nodeLoop.parentRef) {
      if (nodeLoop.parentRef.id == this.insertionPoint.insertionPointLocation.parent_id)
        return false;

      nodeLoop = nodeLoop.parentRef
    }

    return true;
  }


  markToReview(nodeFlat: TodoItemFlatNode) {
    //this.router.navigate(['/reviews/create'], {queryParams: {notebook: '1', }});
    this.router.navigate(['/reviews/create'], {queryParams: {fromNotebook:  1}});

    let nodeItem = this.flatNodeMap.get(nodeFlat);

    this._database.setReviewNote(nodeItem);
  }

  // handle images
  //
  //
  //
  printme(a: string) {
    //console.log("Loaded + " + a);
  }

  includeNodeIdToConnectedList(nodeFlat: TodoItemFlatNode) {
    const nodeItem = this.flatNodeMap.get(nodeFlat);

    // checa se já nao esta antes.
    if (this.allIds.findIndex(a => a == nodeItem.id) < 0)
      this.allIds.push(nodeItem.id);
  }

  async loadImageIfHas(nodeFlat: TodoItemFlatNode) {
    if (nodeFlat.image_path && !this.imgURLIsLoaded(nodeFlat)) {
      // load image here
      const nodeItem = this.flatNodeMap.get(nodeFlat);

      if (!nodeItem.imageDownloadUrl) {

        try {
          //const storageLocal = getStorage();
          nodeItem.imageDownloadUrl = await getDownloadURL(ref(this.storage, nodeFlat.image_path));
        } catch (error) {
          console.log("Opps error = ", error);
          return;
        }
      }
    }
  }

   getImgURL(nodeFlat: TodoItemFlatNode) {
     const nodeItem = this.flatNodeMap.get(nodeFlat);
     return nodeItem.imageDownloadUrl;
   }

   // colocar um observable e um emiter para pegar imagens

   imgURLIsLoaded(nodeFlat: TodoItemFlatNode) {
     const nodeItem = this.flatNodeMap.get(nodeFlat);

     if (nodeItem.imageDownloadUrl)
       return true;

   /*
     getDownloadURL(ref(this.storage, nodeFlat.image_path))
       .then(a => {nodeItem.imageDownloadUrl = a})
       .catch(error => console.log("Opa de erro = ", error));*/

     return false;

   }



  addExpandedChildren(result: TodoItemNode[], nodeItem: TodoItemNode) {

    //result.push(nodeItem);

    // ver porque, mas aparenetemente nao posso chamar uma fucnao do this aqui
    let nodeFlat: TodoItemFlatNode = this.nestedNodeMap.get(nodeItem);

    if (nodeFlat && !this.filterOutNote(nodeFlat))
      result.push(nodeItem);

    if (nodeItem.has_child && nodeItem.children && this.treeControl.isExpanded(nodeFlat)) {
      nodeItem.children.forEach((child) => this.addExpandedChildren(result, child));
    }

  }

  /**
   * This constructs an array of nodes that matches the DOM
   */
  visibleNodes(): TodoItemNode[] {
    const result = [];

    /*
    function addExpandedChildren(nodeItem: TodoItemNode, nodeFlat: TodoItemFlatNode) {
      result.push(nodeItem);

      // ver porque, mas aparenetemente nao posso chamar uma fucnao do this aqui no function
      //let nodeFlat: TodoItemFlatNode = this.nestedNodeMap.get(nodeItem);

      if (nodeItem.has_child && nodeItem.children && this.treeControl.isExpanded(nodeFlat)) {
        nodeItem.children.forEach((child) => addExpandedChildren(child));
      }
    }*/

    this.dataSource.data.forEach((nodeItem) => {
      this.addExpandedChildren(result, nodeItem);
    });

    return result;
  }

  // handle drag and drop
  //
  //
  //
  drop(event: CdkDragDrop<TodoItemFlatNode[]>) {

    // se destino e origem é mesmo, nao faz nada dai

      // No final modify - a prioridade e o pai se for o caso

      // Quando faz update, ver se tem q remove do db -
      // - se está em um pai diferente ou reordena a posicao correta caso mudou prioridade
      //    chama funcao add se for o caso, sempre considera que tem q redordenar dai.
       // para definir prioridade faz a media se as 2 pontas estao no mesmo pai. se no final, incrementa só dai.

       // modifica no db só -- JUSt in time,, tenta documentar ao fazer o codigo na hora, pra faacilitar a vida depois

     // ignore drops outside of the tree
    if (!event.isPointerOverContainer) return;

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    const nodeAtDest = visibleNodes[event.currentIndex];



    //console.log("destinated node is  = " + nodeAtDest.item);
    //console.log("index is = " + (event.currentIndex));

    // Update priority -- also update the max priority of parent

    // get the dragging node
    //    and set the parent to same as the destination node
    //    calculate the prioority to be the avarage between the destination node and the node before, node before must have the same parent
    //        if the node before not exist or its parent is different of destination node, the considerated priority is 0

    // consider if the node is added at the end, if next node is not at the same level as destination
    // have to see if it is gonna be added before or after the destination node

    // if added before, priority = se tem depois ou nao nodo no mesmo level = media ou add 100

    // usa inline flex

    const nodeFlat: TodoItemFlatNode = event.item.data;
    const nodeItem = this.flatNodeMap.get(nodeFlat);

    // Se destino e origem é mesmo, nao faz nada dai
    if (nodeAtDest == nodeItem) return;

    // If destination isn't in the same notebook, do nothing
    if (nodeAtDest.notebook_id != nodeItem.notebook_id) return;

    // Se o nodo destino é descendento direto ou indireto do nodo origem, nao faz nada
    let nodeLoop = nodeAtDest;
    while (nodeLoop) {
      if (nodeLoop == nodeItem)
        return;

      nodeLoop = nodeLoop.parentRef;
    }


    console.log("destinated node is  = " + nodeAtDest.item);
    console.log("index is = " + (event.currentIndex));
    console.log("previous index is = " + (event.previousIndex));

    let after = ((event.currentIndex - event.previousIndex) > 0) ? true:false;

    // pode se que sim, pode se que nao
    //nodeItem.parent_id = nodeAtDest.parent_id;

    let newPriority = 0;

    const nodeAtDestIndex = nodeAtDest.parentRef.children.findIndex((node) => node == nodeAtDest);

    if (after) {
      //const indexAfter = event.currentIndex + 1;
      // ver se acessar indice gera null pointer

      // [ok for now ] TODO calcula da prioridade tem q ser feito com nodos no mesmo nivel e nao nivel diferente

      // [its ok I think] replica e cira um novo no flat - ai fica certo - nao move de um para outro

      const indexAfter = nodeAtDestIndex + 1;

      if ((nodeAtDest.parentRef.children.length > indexAfter))// && visibleNodes[indexAfter].parent_id == nodeAtDest.parent_id)
        //newPriority = (visibleNodes[indexAfter].priority + nodeAtDest.priority)/2;
        newPriority = (nodeAtDest.parentRef.children[indexAfter].priority + nodeAtDest.priority)/2;
      else {
        // adiciona no final
        //newPriority = nodeAtDest.priority + 100;
        newPriority = nodeAtDest.parentRef.maxChildrenPriorityNumber + 100;

         //  muda prioridade do pai tmb caso tenha somado 100 ao ultimo,, faz o update no db..
        nodeAtDest.parentRef.maxChildrenPriorityNumber = newPriority;
        // update parent in firestore to
        // check if it is notebook
        if (nodeAtDest.parentRef.id != nodeAtDest.notebook_id)
          this.notesFirestore.updateNote({id:nodeAtDest.parentRef.id, max_children_priority: newPriority, notebook_id: nodeAtDest.notebook_id});
        else
          this.notebooksFirestore.updateNotebook({id:nodeAtDest.parentRef.id, max_children_priority: newPriority});

        // muda insertion tmb se pai for o ip
        let ipLocation = this.insertionPoint.insertionPointLocation;
        if (ipLocation && (nodeAtDest.parentRef.id == ipLocation.parent_id)) {
          this.insertionPoint.updateInsertionPointInDb({priority: newPriority});
        }
      }

    } else {

      const indexBefore = nodeAtDestIndex - 1;
      if ((indexBefore >= 0))// && (visibleNodes[indexBefore].parent_id == nodeAtDest.parent_id))
        newPriority = (nodeAtDest.parentRef.children[indexBefore].priority + nodeAtDest.priority)/2;
      else
        newPriority = nodeAtDest.priority/2;

    }

    //nodeItem.priority = newPriority;

    //update note to firestore
    this.notesFirestore.updateNote({text: nodeItem.item, id :nodeItem.id,
      priority: newPriority, notebook_id: nodeItem.notebook_id,
      parent_id: nodeAtDest.parent_id});

    // [Solved][Bug] colocar pai como filho dele mesmo nao deixa

    //   [ok]     (another place)
    // quando le modififed no listener,, verifica se pai e node é o mesmo, muda o pai, é automatico dai, só ve questao
    // de orndenadmento - tem q remover da lista do pai e adicionar em outra ,,
    // chama funcao de remover e chama funcao add, só isso

    // only enable drag and drop for notebook page - just alone note
    // if enable for all, not allow move note betoween notebooks,
    //    if allow call remove and add from database, but make a copy of the node before.

    // ao adicionar novo node ou modificar prioridate, tem que sempre atualizar max child priotirity do pai
    // só se nova prioridade for mais que há q existe

    // maybe copy, cut and past in the future for notes


  }

  dropAsChild(event: CdkDragDrop<TodoItemFlatNode>) {

    // get the parent node
    const flatNodeParent = event.container.data;
    const itemNodeParent = this.flatNodeMap.get(flatNodeParent);

    const dragFlatNode = event.item.data as TodoItemFlatNode;
    const dragItemNode = this.flatNodeMap.get(dragFlatNode);

    const newPriority = itemNodeParent.maxChildrenPriorityNumber + 100;
    itemNodeParent.maxChildrenPriorityNumber = newPriority;


    // If destination isn't in the same notebook, do nothing
    if (dragItemNode.notebook_id != itemNodeParent.notebook_id) return;

    // Se o nodo destino é descendento direto ou indireto do nodo origem, nao faz nada
    let nodeLoop = itemNodeParent;

    while (nodeLoop) {
      if (nodeLoop == dragItemNode)
        return;

      nodeLoop = nodeLoop.parentRef;
    }

    //  muda prioridade do pai tmb caso tenha somado 100 ao ultimo,, faz o update no db..
    //         muda insertion tmb se pai for o ip
    // in this case parent node will never be a notebook
    if (itemNodeParent.id != dragItemNode.notebook_id)
      this.notesFirestore.updateNote({id:itemNodeParent.id, max_children_priority: newPriority, has_child: true, notebook_id: itemNodeParent.notebook_id});
    else
      this.notebooksFirestore.updateNotebook({id:itemNodeParent.id, max_children_priority: newPriority, has_child: true});

      // muda insertion tmb se pai for o ip
    let ipLocation = this.insertionPoint.insertionPointLocation;
    if (ipLocation && (itemNodeParent.id == ipLocation.parent_id)) {
      this.insertionPoint.updateInsertionPointInDb({ priority: newPriority });
    }

    //console.log("Dragged to Parent node = " + itemNodeParent.item);

    //TODO muda pai, chama update, muda max priority do pai tmb - do pai primeiro -- faz funcao pra isso
     // tem que atualizar has_child tmb senao tiver

    this.notesFirestore.updateNote({text: dragItemNode.item, id :dragItemNode.id,
      priority: newPriority, notebook_id: dragItemNode.notebook_id,
      parent_id: itemNodeParent.id});

    // [another place] coloca todos os ids para conneted to
  }

  checkIfItIsLastNodeAndNotOpened(nodeFlat: TodoItemFlatNode) {
    if (!nodeFlat.level)
      return false;

    if (nodeFlat.expandable && this.treeControl.isExpanded(nodeFlat)  /*nodeFlat.expandable*/)
      return false;

    const nodeItem = this.flatNodeMap.get(nodeFlat);

    if (nodeItem.parentRef.children[nodeItem.parentRef.children.length - 1] == nodeItem)
      return true;

    return false;
  }

  showNotebookNavigation(nodeFlat: TodoItemFlatNode) {
    if (nodeFlat.level || !this.breakPointService.isHandset)
      return false;

    const nodeItem = this.flatNodeMap.get(nodeFlat);

    if ((nodeItem.currentExpandedNode == nodeItem) || !this.treeControl.isExpanded(nodeFlat))
      return false;

    return true;
  }

  getParentFlatNode(nodeFlat: TodoItemFlatNode) {
    const nodeItem = this.flatNodeMap.get(nodeFlat);
    const parentItem = nodeItem.parentRef;
    return this.nestedNodeMap.get(parentItem);

  }


  getStackNavigationFromNotebook(nodeFlat: TodoItemFlatNode) {
    if (nodeFlat.level)
      return null;

    const nodeItem = this.flatNodeMap.get(nodeFlat);

    return nodeItem.expandadedStack;
  }

  backNavigationToNotebook(nodeFlat: TodoItemFlatNode) {
    const notebookItem = this.flatNodeMap.get(nodeFlat);

    //pop and collapse all
    while (notebookItem.expandadedStack.length > 0) {
      const navItem = notebookItem.expandadedStack.pop();
      const navItemFlat = this.nestedNodeMap.get(navItem);

      if (this.treeControl.isExpanded(navItemFlat)) {
        this.treeControl.collapse(navItemFlat);
      }
    }

    notebookItem.currentExpandedNode = notebookItem;
    this.refreshTreeData();

  }

  backNavigationToNote(nodeItem: TodoItemNode) {
    const notebookItem = nodeItem.notebookRef;
    const navLenght = notebookItem.expandadedStack.length;

    //if current nav, do nothing
    if (nodeItem == notebookItem.expandadedStack[navLenght - 1])
      return;

      //pop and collapse all
    while ((notebookItem.expandadedStack.length > 0)
        && (notebookItem.expandadedStack[notebookItem.expandadedStack.length - 1]) != nodeItem) {
      const navItem = notebookItem.expandadedStack.pop();
      const navItemFlat = this.nestedNodeMap.get(navItem);

      if (this.treeControl.isExpanded(navItemFlat)) {
        this.treeControl.collapse(navItemFlat);
      }
    }

    notebookItem.currentExpandedNode = nodeItem;
    this.refreshTreeData();

  }

  backNavigation(nodeFlat: TodoItemFlatNode) {
    if (nodeFlat.level)
      return;

    const nodeItem = this.flatNodeMap.get(nodeFlat);

    const oldItem = nodeItem.expandadedStack.pop();
    const oldItemFlat = this.nestedNodeMap.get(oldItem);

    if (this.treeControl.isExpanded(oldItemFlat)) {
      this.treeControl.collapse(oldItemFlat);
    }

    const navLength = nodeItem.expandadedStack.length;

    if (navLength > 0) {
      nodeItem.currentExpandedNode = nodeItem.expandadedStack[navLength - 1];
    }else {
      nodeItem.currentExpandedNode = nodeItem;
    }

    this.refreshTreeData();
  }

  truncateString(input: string, maxLength: number = 24): string {
    if (input.length <= maxLength) {
        return input;
    } else {
        return input.slice(0, maxLength - 2) + "..";
    }
  }


  expandOrRouter(node: TodoItemFlatNode) {
    if (node.level || (this.currentPage == 'notebook'))
      this.expandTheNode(node);
    else
      this.router.navigate(['/notebooks/', node.id]);
  }

  showDeleteConfirm(event: MouseEvent): void {
    // interrompe o "fechamento automático" do menu
    event.stopPropagation();
    event.preventDefault();

    this.confirmDelete = true;
  }

  cancelDelete(): void {
    this.confirmDelete = false;
  }

  resetConfirmDelete(): void {
    this.confirmDelete = false;
  }

  hideIconButtons(): boolean {
    // Retorna true se quiser mostrar o ícone somente no hover
    // Retorna false se quiser deixá-lo visível sempre
    return this.breakPointService.isWeb  || this.settings.isChromeExtension();
  }

  newlineToBr(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return value.replace(/\n/g, '<br>');
  }

   transformTextToParagraphs(text: string): string {
    if (!text) {
      return '';
    }

    // Divide em parágrafos para cada \n
    // Se você precisar lidar com \r\n (Windows), use /\r?\n/ em vez de /\n/
    const paragraphs = text.split(/\n/);

    // Envolve cada pedaço em <p>...</p>
    const html = paragraphs
      .map(p => `<span>${p.trim()}</span>`)
      .join('');

    return html;
  }

}


// [] - Ao deletar, fazer nao aparecer mais expandable tmb

